import { STICKY_NAV_SCROLL_DURATION_S } from '@/constants/stickyNav';

import type Lenis from 'lenis';

let lenisInstance: Lenis | null = null;

export function setLenisInstance(instance: Lenis | null): void {
  lenisInstance = instance;
}

export function getLenisInstance(): Lenis | null {
  return lenisInstance;
}

type ScrollToSectionOptions = {
  offset?: number;
  reducedMotion?: boolean;
  /** Fired when the programmatic scroll finishes (or immediately for instant jumps). */
  onComplete?: () => void;
  /** Forwarded to Lenis `scrollTo` so callers can detect their own scrolls. */
  userData?: Record<string, unknown>;
};

export function scrollToSection(
  targetId: string,
  {
    offset = 0,
    reducedMotion = false,
    onComplete,
    userData,
  }: ScrollToSectionOptions = {},
): void {
  const element = document.getElementById(targetId);
  if (!element) return;

  if (reducedMotion) {
    element.scrollIntoView({ behavior: 'auto', block: 'start' });
    onComplete?.();
    return;
  }

  const lenis = getLenisInstance();
  if (lenis) {
    lenis.scrollTo(element, {
      offset,
      duration: STICKY_NAV_SCROLL_DURATION_S,
      onComplete: () => onComplete?.(),
      userData,
    });
    return;
  }

  const handleScrollEnd = () => {
    onComplete?.();
  };

  // Native smooth scroll — `scrollend` when supported; duration fallback otherwise.
  element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  if ('onscrollend' in window) {
    window.addEventListener('scrollend', handleScrollEnd, { once: true });
  } else {
    globalThis.setTimeout(handleScrollEnd, STICKY_NAV_SCROLL_DURATION_S * 1000);
  }
}
